// Ticket 28: Self Rank Card Component
import React, { useEffect, useState } from 'react';
import { fetchSelfRank } from '../api/stats';

const SelfRankCard = ({ range }) => {
  const [rank, setRank] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const loadRank = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await fetchSelfRank(range);
        if (!cancelled) {
          setRank(data);
        }
      } catch (err) {
        console.error('[SelfRank] Failed to load:', err);
        if (!cancelled) {
          setError('Unable to load your rank');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadRank();

    return () => {
      cancelled = true;
    };
  }, [range]);

  if (loading && !rank) return null;
  if (error || !rank) return null;

  const {
    gifter_rank,
    top1_spent,
    you_spent,
    loved_rank,
    top1_received,
    you_received,
  } = rank;

  if (!gifter_rank && !loved_rank) return null;

  return (
    <div className="rounded-2xl bg-slate-800/80 border border-slate-700/50 px-4 py-3 text-xs text-slate-100">
      <p className="mb-1 text-[11px] font-semibold text-slate-300">
        Your Rankings ({range === 'weekly' ? 'Weekly' : 'All Time'})
      </p>
      {gifter_rank && (
        <p className="text-[11px]">
          🏆 Gifter Rank: <span className="font-semibold text-pink-400">#{gifter_rank}</span>
          {top1_spent != null && top1_spent > 0 && (
            <span className="ml-1 text-[10px] text-slate-400">
              (Top gifter: {top1_spent?.toLocaleString?.()} coins)
            </span>
          )}
        </p>
      )}
      {loved_rank && (
        <p className="text-[11px] mt-1">
          💖 Most Loved Rank: <span className="font-semibold text-pink-400">#{loved_rank}</span>
          {top1_received != null && (
            <span className="ml-1 text-[10px] text-slate-400">
              (Top has {top1_received} gifts)
            </span>
          )}
        </p>
      )}
    </div>
  );
};

export default SelfRankCard;
